module.exports = __webpack_public_path__ + "static/img/banner.b8626b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png?v=20220701
// module id = ct/K
// module chunks = 1